// extracted by mini-css-extract-plugin
var _1 = "ArW4H";
var _2 = "XHyDu";
var _3 = "r3TO2";
var _4 = "B8wCm";
var _5 = "bBFxl";
var _6 = "MMUuD";
var _7 = "jnxx3";
var _8 = "zn_uk";
var _9 = "HCZ5R";
var _a = "VGs6o";
export { _1 as "icon", _2 as "invoice-details", _3 as "invoice-details-body", _4 as "invoice-details-header", _5 as "invoice-details-label", _6 as "invoice-details-label-value", _7 as "invoice-details-label-value--bold", _8 as "invoice-details-label-value-title", _9 as "invoice-details-value", _a as "invoice-details-wrapper" }
